import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import loadable from '@loadable/component';
import {
    getCurrentSize,
    onContainerSizeChange,
    observeContainerDimensions,
} from '../Utils/ContainerSize';

import 'normalize.css';
import '../styles/layout/layout.scss';
import '../styles/spectate-client.scss';
import BetfinderPortal from './BetfinderPortal';
import BuildInfo from '~spa/Components/BuildInfo/BuildInfo';
import SeoNavigation from '~spa/Components/SeoNavigation/SeoNavigation';
import Modals from '~shared/components/modal-overlay/Modals';
import { isVirtualSportsPage } from '../Utils/VirtualSports';
import { loadSkinVariables } from '../Utils/Skins';
import { isSportcallerPage } from '../Pages/Sportcaller/utils';
import { SPORTCALLER } from '../Pages/Sportcaller/constants';
import { onThemeChange } from '~shared/utils/user';
import { getThemeClass, pushGTMTheme } from '~spa/Utils/Skins';

const Betslip = loadable(
    () => import(/* webpackChunkName: "betslip" */ '~Betslip')
);

const SPECTATE_CLIENT_CLASS = 'spectateClient';
const BEM_CLASS = 'l';

class Layout extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            size: getCurrentSize(),
            theme: getThemeClass(),
        };
    }

    componentDidMount() {
        pushGTMTheme();
        loadSkinVariables();
        observeContainerDimensions(this.state.size);
        onContainerSizeChange(
            newSize => this.setState({size: newSize})
        );
        onThemeChange(() => {
            this.setState({theme: getThemeClass()});
        });
    }

    showSidebar(url) {
        return !isVirtualSportsPage(url) && !isSportcallerPage(url);
    }

    render() {

        const {
            children,
            currentUrlPath,
        } = this.props;

        const layoutClasses = classNames(
            SPECTATE_CLIENT_CLASS,
            this.state.theme,
            {
                [`${BEM_CLASS} ${BEM_CLASS}--${this.state.size}`]: this.showSidebar(currentUrlPath),
            }
        );

        return (
            <React.Fragment>
                <div className={layoutClasses}>
                <Modals />
                    <main className={`${BEM_CLASS}__content`}>
                        <BuildInfo />
                        <SeoNavigation
                            locationState={this.props.history.location.state}
                        />
                        {children}
                    </main>

                    <BetfinderPortal />

                    {/**
                     * We have extra logic to hide the betslip on Racing pages
                     * it was needed to implement in this hacky way as we don't
                     * have the URL's and the tab is rendered inside the container
                     * without rerendering the entire page
                     * tickets related:
                     * https://dedsert.atlassian.net/browse/AM-4327
                     * https://dedsert.atlassian.net/browse/AM-4155
                     * @see client/src/shared/components/react/VirtualSportWidget/VirtualSportWidget.jsx
                     */
                     !isVirtualSportsPage(currentUrlPath) && <aside className={`${BEM_CLASS}__sidebar ${isSportcallerPage(currentUrlPath) ? SPORTCALLER : ''}`}>
                        <Betslip />
                    </aside>}
                </div>
            </React.Fragment>
        );
    }
}

Layout.propTypes = {
    children: PropTypes.node.isRequired,
    isLoggedIn: PropTypes.bool.isRequired,
    currentUrlPath: PropTypes.string,
    history: PropTypes.object,
};

export default Layout;
